import React from 'react'
import ListController from '../../components/ListController'
import PropTypes from 'prop-types'
import PagesList from './PagesList'
import { listPages } from '../../api/pages'

class PagesListContainer extends React.PureComponent {
  constructor (props, context) {
    super(props, context)
    const filters = {}
    const path = props.match.url

    if (path === '/recent-pages') {
      filters.anyParent = true
      filters.fetchPath = true
    }

    const sortBys = [
      'showTab',
      'tabOrder',
      'updatedAt',
      'updatedBy',
      'createdAt',
      'slug',
      'title'
    ]

    this.state = {
      sortBys,
      filters,
      fetchList: listPages,
      initialSortBy: 'updatedAt'
    }
  }

  render () {
    return <ListController
      {...this.props}
      {...this.state}
      displayComponent={PagesList} />
  }
}

PagesListContainer.propTypes = {
  match: PropTypes.object
}

export default PagesListContainer



// WEBPACK FOOTER //
// ./src/pages/PagesList/PagesListContainer.js